import { ThemeUICSSObject } from 'theme-ui';
import { getOneColorState } from '../../../../../methods';
/* IMPORT HERE */

const switchMultiple: ThemeUICSSObject = {
  height: '53px',
  display: 'inline-flex',
  borderColor: 'pallete.border.field',
  backgroundColor: '#e0e0e0',
  borderRadius: 'default',
  boxShadow: 'none',
  p: '4px',
  '&.touched': { borderColor: 'pallete.border.field' },
  '.switchButton': (theme) => {
    const colorState = getOneColorState(
      'palette.primary.main',
      'disabled',
      theme.palette,
    );

    return {
      boxShadow: 'none',
      flex: 1,
      minWidth: 0,
      borderRadius: 'default',
      textTransform: 'none',
      px: 2,
      py: 1,

      backgroundColor: colorState,
      color: 'palette.text.disabled',

      '&:hover': {
        backgroundColor: colorState,
        color: 'palette.text.disabled',
      },
      '&:hover:not(.active)': {
        backgroundColor: colorState,
        color: 'palette.text.disabled',
      },

      '&.active': {
        backgroundColor: 'palette.primary.main',
        color: 'palette.primary.contrastText',
        '&:hover': {
          backgroundColor: 'palette.primary.main',
          color: 'palette.text.secondary',
        },
      },
      '&.first': {
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '0px',
      },
      '&.last': { borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' },
      '&.middle': {
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '0px',
      },
    };
  },
};

export default switchMultiple;
